<div class="content-area">
  <div class="clr-row">
    <div class="clr-col-10 clr-col-md-8">
      <h1>Unelte</h1>
    </div>
    <div class="clr-col-10 clr-col-md-8" id="posts-wrapper">
      <div class="clr-row">
        <div class="clr-col-12">
          <a href="https://generator-cuvinte.funbible.net/" class="card clickable clr-row p-3">
            <div class="card-img clr-col-12 clr-col-md-4 px-2"
                 style="background-image: url('assets/word-search-generator.png');">
            </div>
            <div class="card-block clr-col-12 clr-col-md-8">
              <div class="card-title"><h2>Generator de cuvinte ascunse</h2></div>
              <div class="card-tags">
                <!-- <span class="tag mr-1 py-1 px-2">Generator</span>
                <span class="tag mr-1 py-1 px-2">Educativ</span> -->
                <div>
                  <button class="activity-button" aria-label="Deschide Generator de cuvinte ascunse">
                    <fa-icon icon="play"></fa-icon>
                  </button>
                </div>
              </div>
              <p class="card-text">
                Generează cu ușurință puzzle-uri cu cuvinte ascunse pentru activitățile tale educative și distractive. Apoi le poți imprima sau partaja online.
              </p>
            </div>
          </a>
        </div>
        <div class="clr-col-12">
          <div class="card disabled-card clr-row p-3">
            <div class="card-img clr-col-12 clr-col-md-4 px-2 under-construction">
              <div class="construction-placeholder">
                <fa-icon icon="hammer" class="construction-icon"></fa-icon>
                <span class="construction-text">În construcție</span>
              </div>
            </div>
            <div class="card-block clr-col-12 clr-col-md-8">
              <div class="card-title"><h2>Generator de cuvinte încurcișate</h2></div>
              <div class="card-tags">
                <span class="coming-soon-badge">În curând</span>
                <div>
                  <button class="activity-button disabled" disabled aria-label="Generator de cuvinte încurcișate - în curând">
                    <fa-icon icon="lock"></fa-icon>
                  </button>
                </div>
              </div>
              <p class="card-text">
                Creează exerciții distractive cu cuvinte amestecate pe care copiii trebuie să le descurce. Perfect pentru dezvoltarea abilităților de citire și vocabular.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
